import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

// Hook to check if an ingredient line has associated ingredients
export function useCheckIngredientLineIngredients() {
    const query = useMutation({
        mutationFn: async (ingredientLineId: number) => {
            try {
                // First, get the ingredient line details to get its name
                const ingredientLineResponse = await loggedInApiCall.get(`/api/ingredient_lines/${ingredientLineId}`);
                const ingredientLineName = ingredientLineResponse.data.name;

                // Then check if there are ingredients associated with this ingredient line by name
                const response = await loggedInApiCall.get(
                    `/api/ingredients?ingredientLine.name=${encodeURIComponent(ingredientLineName)}&itemsPerPage=1`,
                );

                return {
                    hasIngredients: response.data["hydra:totalItems"] > 0,
                    totalIngredients: response.data["hydra:totalItems"],
                };
            } catch {
                // If we can't check, assume it's safe to proceed
                return { hasIngredients: false, totalIngredients: 0 };
            }
        },
    });

    return query;
}
